import React, {useState} from 'react';
import {ViewSpeciesModal} from "../../../Pages/SpeciesLists/Common/Modals/ViewSpeciesModal";
import {service as SpeciesService} from "../../../../Services/SpeciesService";

export const UpdateSpeciesActivityFeedItemDescription = props => {
    const {Event: contextNodeActivity = null} = props;
    const {Activity: activity = null} = contextNodeActivity;
    const {data = null} = activity;
    const oldSpecies = data?.oldData;
    const newSpecies = data?.newData;
    const speciesTitle = SpeciesService.GetFullTitle(oldSpecies ?? newSpecies);

    let verb = 'updated';
    const [showModal, setShowModal] = useState(false);

    return <p>
        <ViewSpeciesModal
            show={showModal}
            species={newSpecies}
            onHide={() => setShowModal(false)}
            warning={"The below information is a point-in-time snapshot of the species data which may be outdated. "}
        />
        {activity?.User?.name ?? "Unknown user"} {verb} the
        {' '}
        {data?.fieldName ?? "species details"} of
        {' '}
        <a className="link-primary" onClick={_ => setShowModal(true)}>
            {speciesTitle}
        </a>.
    </p>;
};


